/* istanbul ignore file */
import dayjs from 'dayjs';
import VueRouter from 'vue-router';
import VueYouTubeEmbed from 'vue-youtube-embed';
import createRouter from './router';
import createStore from './store';
import App from './App';
import 'dayjs/locale/id';

function createApp({ Vue, Vuex, data = {}, isSSR = true } = {}) {
  Vue.use(VueRouter);
  Vue.use(Vuex);
  Vue.use(VueYouTubeEmbed);
  dayjs.locale('id');

  const router = createRouter(VueRouter);
  const store = createStore(Vuex);

  if (data) {
    store.replaceState({ server: data });
  }

  const app = new Vue({
    store,
    router,
    data: () => ({
      isSSR,
    }),
    render: h => h(App),
  });

  return {
    app,
    store,
    router,
  };
}

export default createApp;
